import { render, staticRenderFns } from "./BaseEventsHorizontalList.vue?vue&type=template&id=16b23a08"
import script from "./BaseEventsHorizontalList.vue?vue&type=script&lang=js"
export * from "./BaseEventsHorizontalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports